import React from 'react';
import { Box, Flex, Button, Heading, useDisclosure, IconButton, Stack, Collapse, HStack, Text } from '@chakra-ui/react';
import { Menu, X, Terminal } from 'lucide-react';
import { DarkModeToggle } from './DarkModeToggle';
import { motion } from 'framer-motion';
const MotionBox = motion(Box);
const MotionFlex = motion(Flex);
export function Header() {
  const {
    isOpen,
    onToggle
  } = useDisclosure();
  return <Box as="header" bg="rgba(10, 10, 15, 0.8)" backdropFilter="blur(10px)" position="sticky" top={0} zIndex={10} width="100%" borderBottom="1px" borderColor="rgba(0, 153, 255, 0.3)" boxShadow="0 0 20px rgba(0, 153, 255, 0.2)" data-id="element-167">
      <Flex as="nav" align="center" justify="space-between" wrap="wrap" padding="1rem" maxW="1200px" mx="auto" data-id="element-168">
        <MotionFlex align="center" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-169">
          <Terminal size={24} color="#0099ff" strokeWidth={2.5} style={{
          marginRight: '10px'
        }} data-id="element-170" />
          <Heading as="h1" size="md" letterSpacing="tight" fontWeight="bold" bgGradient="linear(to-r, neonBlue.400, neonPurple.400)" bgClip="text" data-id="element-171">
            George_K@Quarshie:~$
          </Heading>
        </MotionFlex>
        <HStack spacing={2} data-id="element-172">
          <DarkModeToggle data-id="element-173" />
          <IconButton display={{
          base: 'block',
          md: 'none'
        }} onClick={onToggle} icon={isOpen ? <X size={24} data-id="element-175" /> : <Menu size={24} data-id="element-176" />} variant="ghost" aria-label="Toggle Navigation" color="neonBlue.400" _hover={{
          bg: 'rgba(0, 153, 255, 0.1)'
        }} data-id="element-174" />
        </HStack>
        <Stack direction={{
        base: 'column',
        md: 'row'
      }} display={{
        base: 'none',
        md: 'flex'
      }} width={{
        base: 'full',
        md: 'auto'
      }} alignItems="center" flexGrow={1} mt={{
        base: 4,
        md: 0
      }} spacing="1.5rem" justifyContent="flex-end" data-id="element-177">
          {['About', 'Skills', 'Services', 'Projects', 'Contact'].map((item, index) => <MotionBox key={item} initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} data-id="element-178">
                <Text as="a" href={`#${item.toLowerCase()}`} fontFamily="mono" fontSize="sm" color="whiteAlpha.800" position="relative" _hover={{
            color: 'neonBlue.400',
            _after: {
              width: '100%',
              left: '0'
            }
          }} _after={{
            content: '""',
            position: 'absolute',
            width: '0',
            height: '2px',
            bottom: '-2px',
            right: '0',
            bg: 'neonBlue.400',
            transition: 'width 0.3s ease, left 0.3s ease'
          }} data-id="element-179">
                  {`<${item} />`}
                </Text>
              </MotionBox>)}
        </Stack>
        <Box display={{
        base: 'none',
        md: 'block'
      }} ml={4} data-id="element-180">
          <MotionBox initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.6
        }} data-id="element-181">
            <Button as="a" href="#contact" variant="neonBlue" size="sm" _hover={{
            bg: 'rgba(0, 153, 255, 0.15)',
            boxShadow: '0 0 15px rgba(0, 153, 255, 0.5)'
          }} data-id="element-182">
              Connect()
            </Button>
          </MotionBox>
        </Box>
        <Collapse in={isOpen} animateOpacity data-id="element-183">
          <Stack mt={4} display={{
          md: 'none'
        }} spacing={4} divider={<Box border="1px" borderColor="rgba(0, 153, 255, 0.2)" width="100%" data-id="element-185" />} data-id="element-184">
            {['About', 'Skills', 'Services', 'Projects', 'Contact'].map(item => <Text key={item} as="a" href={`#${item.toLowerCase()}`} py={2} fontFamily="mono" fontSize="sm" color="whiteAlpha.800" _hover={{
            color: 'neonBlue.400'
          }} data-id="element-186">
                  {`<${item} />`}
                </Text>)}
            <Button as="a" href="#contact" variant="neonBlue" size="sm" width="100%" data-id="element-187">
              Connect()
            </Button>
          </Stack>
        </Collapse>
      </Flex>
    </Box>;
}